import callApi from './backendService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/tags`;

export const getTags = () => callApi({
  endpoint: basePath
});

export const getMemberTags = (member_uuid) => callApi({
  endpoint: `${basePath}/${member_uuid}`
});

export const storeTags = (store_info) => callApi({
  method: 'POST',
  endpoint: basePath,
  body: store_info
});
